'use client'

import * as React from 'react'
import { Drawer as DrawerPrimitive } from 'vaul'

import { StyledContent, StyledOverlay } from './Drawer.styles'

const Overlay = React.forwardRef<
  React.ElementRef<typeof StyledOverlay>,
  React.ComponentProps<typeof StyledOverlay>
>((props, ref) => <StyledOverlay data-slot="drawer-overlay" ref={ref} {...props} />)

const Content = React.forwardRef<
  React.ElementRef<typeof StyledContent>,
  React.ComponentProps<typeof StyledContent>
>(({ children, ...props }, ref) => (
  <DrawerPrimitive.Portal data-slot="drawer-portal">
    <Overlay />

    <StyledContent data-slot="drawer-content" ref={ref} {...props}>
      <div className="drawer-handle bottom" />
      {children}
    </StyledContent>
  </DrawerPrimitive.Portal>
))

export const Drawer = {
  Close: DrawerPrimitive.Close,
  Content,
  Description: DrawerPrimitive.Description,
  Overlay,
  Portal: DrawerPrimitive.Portal,
  Root: DrawerPrimitive.Root,
  Title: DrawerPrimitive.Title,
  Trigger: DrawerPrimitive.Trigger,
}
